// src/components/AuthRoute.tsx
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface AuthRouteProps {
    children: ReactNode;
    requiredRole?: "SuperAdmin" | "ExamAdmin";
}

export default function AuthRoute({ children, requiredRole }: AuthRouteProps) {
    const { user, role } = useAuth();

    // Not logged in → redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If a requiredRole is passed, enforce it
    if (requiredRole) {
        // ✅ SuperAdmin can access everything
        if (role === "SuperAdmin") {
            return <>{children}</>;
        }

        // ❌ Wrong role → block access
        if (role !== requiredRole) {
            return (
                <div className="min-h-screen flex items-center justify-center">
                    <p className="text-red-600 font-medium">
                        ❌ Access denied. This page requires {requiredRole} privileges.
                    </p>
                </div>
            );
        }
    }

    // Default → allow access
    return <>{children}</>;
}
